import React, { useRef } from 'react'
import { Helmet } from 'react-helmet'
import PhotoHolder from '../components/photo-holder'
import { useNavigate } from "react-router-dom";
import './photo.css'

const Photo = (props) => {

  const canvas = useRef()
  const video = useRef();
  const navigate = useNavigate();

  const renderImage = ()=>{
    canvas.current.getContext('2d').drawImage(video.current, 0, 0, canvas.current.width, canvas.current.height);
   	const image_data_url = canvas.current.toDataURL('image/jpeg');
    video.current.srcObject.getTracks().forEach((track) => {
      track.stop();
    });
    navigate("/photo-approval", { state:{
      photoUrl: image_data_url
    }});
  }

  return (
    <div className="photo-container">
      <Helmet>
        <title>Photo - Hackathon</title>
        <meta property="og:title" content="Photo - Hackathon" />
      </Helmet>
      <PhotoHolder 
        rootClassName="photo-holder-root-class-name1" 
        video={video}
      />
      <canvas id="canvas" ref={canvas}/>
      <button className='button' onClick={renderImage}>
        <img
          alt="image"
          src="/playground_assets/camera.png"
          className="photo-image"
        />
      </button>
    </div>
  )
}

export default Photo
